import { render, staticRenderFns } from "./ActivateMenu.vue?vue&type=template&id=d0a27c18"
import script from "./ActivateMenu.vue?vue&type=script&lang=js"
export * from "./ActivateMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports